import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import { Button } from '@roc/ui';

const useStyles = makeStyles({
  container: {
    paddingTop: 16,
  },
});

export const NoCDAAvailable = ({ globalStore, handleClose }) => {


  const classes = useStyles();
  return (<Grid container justifyContent="center" className={classes.container}>
    <Grid item xs={11}>
      <Alert severity="info">Please reach out to the Underwriter to get the Second Appraisal/ARR</Alert>
    </Grid>

    <Grid item container xs={11} justifyContent='flex-end' style={{ paddingTop: '16px' }}>
      <Grid item>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClose}
          testId="cancel"
        >
          Close
        </Button>
      </Grid>
    </Grid>
  </Grid>
  )
}